import videoPlayer from "./videoPlayer";

export default `
${videoPlayer}
`;
